import moment from "moment/moment";
import {
  createAccountVoucherData,
  createLevel2Data,
  createLevel3Data,
  createVoucherData,
  deleteLevel1Data,
  deleteLevel2Data,
  deleteLevel3Data,
  deleteVoucherData,
  getSpecificVoucherData,
  getVoucherData,
  getVoucherDataByDate,
  getVoucherDataInRange,
  updateLevel1Data,
  updateLevel2Data,
  updateLevel3Data,
  updateVoucherData,
} from "../../api/restApi";
import { getMonthYearFromDate } from "../Level/utils";

export const getSpecificVoucher = async (month, type, number) => {
  let response = await getSpecificVoucherData(month, type, number);
  console.log(response);
  return response?.data;
};

export const getAllVoucherData = async (lev1, lev2, lev3) => {
  let VoucherData = await getVoucherData(lev1, lev2, lev3);
  console.log(VoucherData);
  return VoucherData.data;
};

export const getAllVoucherDataByDate = async (levels, currentDate) => {
  let [lev1, lev2, lev3] = levels.split("-");
  let VoucherDateByDay = await getVoucherDataByDate(
    lev1,
    lev2,
    lev3,
    currentDate
  );
  return VoucherDateByDay.data;
};

export const getAllVoucherDataInRange = async (levels, start, end) => {
  console.log(levels, start, end);
  let [lev1, lev2, lev3] = levels.split("-");
  let voucherData = await getVoucherDataInRange(lev1, lev2, lev3, start, end);
  console.log(voucherData);
  return voucherData.data;
};

export const saveLevel2 = async (fullcode, data) => {
  let level1code = fullcode.split("-")[0];
  let level2code = fullcode.split("-")[1];
  let response = await createLevel2Data(level1code, level2code, data);
  return response;
};

export const saveLevel3 = async (fullcode, data) => {
  let level1code = fullcode.split("-")[0];
  let level2code = fullcode.split("-")[1];
  let level3code = fullcode.split("-")[2];
  let response = await createLevel3Data(
    level1code,
    level2code,
    level3code,
    data
  );
  return response;
};

export const saveAccountVoucher = async (type, data) => {
  var month = getMonthYearFromDate(data.voucherDate.toString());
  data = {
    ...data,
    voucherMonth: month,
  };
  let response = await createAccountVoucherData(type, data);
  return response;
};
export const saveNewVoucher = async (name, data, creditTotal) => {
  var month = getMonthYearFromDate(data.voucherDate.toString());
  data = {
    ...data,
    // creditTotal: creditTotal,
    voucherMonth: month,
  };
  let response = await createVoucherData(name, data);
  return response;
};

export const updateLevel1 = async (fullcode, data) => {
  let response = await updateLevel1Data(fullcode, data);
  return response;
};

export const updateLevel2 = async (fullcode, data) => {
  let level1code = fullcode.split("-")[0];
  let level2code = fullcode.split("-")[1];
  let response = await updateLevel2Data(level1code, level2code, data);
  return response;
};

export const updateLevel3 = async (fullcode, data) => {
  let level1code = fullcode.split("-")[0];
  let level2code = fullcode.split("-")[1];
  let level3code = fullcode.split("-")[2];
  let response = await updateLevel3Data(
    level1code,
    level2code,
    level3code,
    data
  );
  return response;
};

export const updateVoucher = async (type, date, voucher, index) => {
  voucher.voucherDate = moment(date).format("DD/MM/YYYY");
  console.log(type, voucher, index);

  let response = await updateVoucherData(type, voucher, index);
  return response;
};

export const deleteLevel1 = async (fullcode) => {
  let response = await deleteLevel1Data(fullcode);
  return response;
};

export const deleteLevel2 = async (fullcode) => {
  let level1code = fullcode.split("-")[0];
  let level2code = fullcode.split("-")[1];
  let response = await deleteLevel2Data(level1code, level2code);
  return response;
};

export const deleteLevel3 = async (fullcode) => {
  let level1code = fullcode.split("-")[0];
  let level2code = fullcode.split("-")[1];
  let level3code = fullcode.split("-")[2];
  let response = await deleteLevel3Data(level1code, level2code, level3code);
  return response;
};

export const deleteVoucher = async (type, data, index) => {
  console.log(type, data, index);
  
  data.voucherDate = moment(data.voucherDate).format("DD/MM/YYYY");
  let response = await deleteVoucherData(type, data, index);
  return response;
};
